<template>
  <div> 
    <v-row class="ma-8">
      <v-col cols="12" >
        <p class="formTitle my-0">{{$t('privacy.title')}}</p>
        <p class="ffP fs16 fcT240 my-2">{{$t('privacy.subtitle1')}}</p>
        <p class="ffP fs16 fcT2 mb-1">{{$t('privacy.text1') }}</p>  
        <br>
        <p class="ffP fs16 fcT240 my-2">{{$t('privacy.subtitle2')}}</p>
        <p class="ffP fs16 fcT2 mb-1">{{$t('privacy.text2') }}</p>  
        <br>
        <p class="ffP fs16 fcT240 my-2">{{$t('privacy.subtitle3')}}</p>
        <p class="ffP fs16 fcT2 mb-1">{{$t('privacy.text3') }}</p>  
        <br>
        <p class="ffP fs16 fcT240 my-2">{{$t('privacy.subtitle4')}}</p>
        <p class="ffP fs16 fcT2 mb-1">{{$t('privacy.text4') }}</p>  
        <br>
        <p class="ffP fs16 fcT240 my-2">{{$t('privacy.subtitle5')}}</p>
        <p class="ffP fs16 fcT2 mb-1">{{$t('privacy.text5') }}</p>  
        <br>
        <p class="ffP fs16 fcT240 my-2">{{$t('privacy.subtitle6')}}</p>
        <p class="ffP fs16 fcT2 mb-1">{{$t('privacy.text6') }}</p>
        <br>  
        <p class="ffP fs16 fcT240 my-2">{{$t('privacy.subtitle7')}}</p>
        <p class="ffP fs16 fcT2 mb-1">{{$t('privacy.text7') }}</p>           
      </v-col>
    </v-row>
    <v-row class="ma-8">
      <v-col cols="12">
        <v-btn class="datPrimaryBtn" depressed @click="fClose">{{$t('datBtn.accept')}}</v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>

export default {
  methods: {
    // Cierra la modal
    fClose(){
      this.$emit('close')
    }
  }
}
</script>

 